import Vue from "vue";
// 导入i18n
import i18n from "@/i18n/index.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins";
import "./router/permission";
import tinymce from "tinymce";
import VueTinymce from "@packy-tang/vue-tinymce";
// Vue.prototype.$eventBus = new Vue();
Vue.prototype.$tinymce = tinymce; // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce); // 安装vue的tinymce组件
// Vue.component("Blob", Blob);
// Vue.component("Export2Excel", Export2Excel);
// 经过封装的富文本插件
import TinyMce from "@/components/tinymce/Tinymce";
Vue.component("TinyMce", TinyMce);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
